import { formatCurrency } from "@/utils/format-currency";
import { format, parseISO, isValid } from "date-fns";
import { DisputeStatusChip } from "./dispute-status-chip";
import { ComplaintActionsPopover } from "./complaint-actions-popover";
import { COMPLAINT_STATUS, COMPLAINT_TYPE_LABEL } from "../../data";

const formatDate = (date) => {
  if (!date) return "N/A";
  const parsed = parseISO(date);
  return isValid(parsed) ? format(parsed, "MMM d, yyyy") : "N/A";
};

export const ComplaintColumns = [
  {
    accessorKey: "merchantComplaintId",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Complaint ID</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>{row.original.merchantComplaintId}</div>
    ),
  },
  {
    accessorKey: "merchantName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Merchant</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.merchantName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "disputeType",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Type</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {COMPLAINT_TYPE_LABEL[row.original.disputeType] ?? row.original.disputeType ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "disputeAmount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Amount</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.disputeAmount ? formatCurrency(row.original.disputeAmount) : "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "disputeStatus",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => (
      <DisputeStatusChip status={row.original.disputeStatus} config={COMPLAINT_STATUS} />
    ),
  },
  {
    accessorKey: "dateCreated",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date Created</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {formatDate(row.original.dateCreated)}
      </div>
    ),
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Actions</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", cursor: "pointer" }}>
        <ComplaintActionsPopover complaint={row.original} />
      </div>
    ),
  },
];
